import * as amplitude from '@amplitude/analytics-browser';
import { identify } from '@amplitude/analytics-browser';
import { storageHelper, User } from '@spo/logic';
import { useEffect } from 'react';

export const useAmplitudeUser = () => {
  const user = storageHelper.getItem<User>('user');

  useEffect(() => {
    if (user) {
      amplitude.setUserId(user.uid);
      const identityEvent = new amplitude.Identify();
      identityEvent.set('job', user.jobname);
      identify(identityEvent);
    }
  }, [user?.uid]);
};
